<template>
  <section-page title="Billing Portal" is-short>
    <p class="subscription_message mb-100" v-if="hasWhiteGlove">
      <strong>Your account comes with white-glove service</strong>
    </p>

    <p class="subscription_message mb-100" v-if="isOnGracePeriod">
      <strong>Account Is Canceled</strong> <br />
      You're currently in your grace period of Forefront until the end of this
      billing period. During this time you will have access to Forefront and may
      <a @click="openBillingPortal">resume your subscription</a> if you wish to
      continue using Forefront.
    </p>

    <div class="flex">
      <button-outlined
        class="mr-75"
        size=""
        @click="openBillingPortal"
      >
        Visit Billing Portal
      </button-outlined>

      <button-outlined
        v-if="!hasWhiteGlove"
        size=""
        @click="purchaseWhiteGlove"
        :loading="isPurchasing"
      >
        Purchase White Glove Service
      </button-outlined>
    </div>
  </section-page>
</template>

<script>
import { ENUMS } from "../../../services/enums";
import api from "../../../api";

export default {
  name: "AccountPaymentMethod",
  data() {
    return {
      isPurchasing: false,
    };
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    isOnGracePeriod() {
      return this.account.status === ENUMS.AccountStatusEnum.GracePeriod.value;
    },
    hasWhiteGlove() {
      return this.$store.getters["accounts/hasWhiteGloveService"];
    },
  },
  methods: {
    purchaseWhiteGlove() {
      this.isPurchasing = true;
      api.accounts.purchaseWhiteGlove(this.account.id)
        .then((res) => {
          console.log(res);
          window.open(res.data);
        })
        .finally(() => {
          this.isPurchasing = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.subscription_message {
  line-height: 1.3;
}
</style>
